import React from "react"
import {AsyncResultModal} from "../../AsyncResultModal/AsyncResultModal"
import {refreshAndClose} from "../../../utilities/modals"
import {ErrorDocument} from "../../../resources/common"
import {AsyncResultIdleRequestState} from "../../../types/asyncResultIdle"

interface SaveRiskSettingsConfirmationModalProps {
	state: AsyncResultIdleRequestState<any, ErrorDocument>
	onSubmit: () => Promise<void>
	close: () => void
	refresh: () => void
}
export default function SaveRiskSettingsConfirmationModal({
	state,
	onSubmit,
	close,
	refresh,
}: SaveRiskSettingsConfirmationModalProps) {
	return (
		<AsyncResultModal
			title="Save changes?"
			buttonText="Save changes"
			buttonClassname="is-success is-outlined"
			cancelButtonText="Keep editing"
			cancelButtonClassname="button is-white"
			state={state}
			onSubmit={onSubmit}
			successText="Updated Succesfully"
			errorToText={(err) => err.errors?.[0].title ?? "An error has occurred"}
			close={close}
			onSuccess={refreshAndClose(refresh, close)}
			onSuccessDelay={1500}
			disableCloseOnSuccess
		>
			Are you sure you want to save the changes?
		</AsyncResultModal>
	)
}
